<template>
  <v-sheet class="search-event-card pa-4 mb-4" elevation="1" outlined>
    <h3>
      <span>#{{ id }}:</span> {{ title }}
    </h3>
    <div v-if="dateString">{{ dateString }}</div>
    <v-chip v-if="draft" color="red" dark small class="mt-2">Черновик </v-chip>
    <div v-if="address">{{ address }}</div>
    <div v-if="outcomes.length">
      <div v-for="group in outcomes" :key="group.group_id">
        <v-sheet
          v-for="comp in group.list"
          :key="comp.track_id"
          class="pa-4 my-4"
          outlined
        >
          <div>{{ group.name }}: {{ comp.competenceName }}</div>
          <v-simple-table class="mb-3">
            <template #default>
              <thead>
                <tr>
                  <th
                    v-for="item in comp.outcome"
                    :key="item.roleName"
                    class="text-left"
                  >
                    {{ item.roleName }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td v-for="item in comp.outcome" :key="item.roleName">
                    {{ item.maxScoreText }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </div>
    </div>
    <div v-else>
      <div class="text-caption mt-4">
        Это мероприятие не состоит в компетенциях
      </div>
    </div>
  </v-sheet>
</template>

<script>
import dayjs from "@/plugins/dayjs";
import { mapOutcomes } from "./utils";
// import { BASE_ACHIEVEMENT_ROLE_NAMES } from "@/constants";

export default {
  name: "SearchEventCard",
  props: {
    id: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    start: {
      type: String,
      required: false,
    },
    end: {
      type: String,
      required: false,
    },
    address: {
      type: String,
      required: false,
    },
    settings: {
      type: Array,
      default: () => {
        return [];
      },
    },
    draft: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dateString() {
      const { start, end } = this;
      const result = [];
      !!start && result.push(start);
      !!end && result.push(end);

      return result
        .map((d) => {
          return dayjs(d).format("DD.MM.YYYY HH:mm");
        })
        .join(" - ");
    },
    outcomes() {
      const allTracks = this.$store.state.compTracks;
      const competences = this.$store.state.competences;
      const groups = this.$store.state.groups;
      const roles = this.$store.state.talent.achievementRoles || [];
      const result = this.settings.reduce((acc, setting) => {
        const track = allTracks[setting.track_id];
        const comp = competences.find((n) => n.id === track?.competence_id);
        const group = groups[comp?.group_id];

        if (!acc[comp?.group_id ?? "ungrouped"]) {
          acc[comp?.group_id ?? "ungrouped"] = {
            name: group?.name || "Без группы",
            group_id: comp?.group_id ?? "ungrouped",
            list: [],
          };
        }
        acc[comp?.group_id ?? "ungrouped"].list.push({
          track_id: setting.track_id,
          competenceName: comp?.name,
          score: setting.score,
          maxScore: setting.max_score,
          outcome: mapOutcomes(
            setting.outcome,
            setting.score,
            setting.max_score,
            roles
          ),
        });
        return acc;
      }, {});

      return Object.values(result);
    },
  },
};
</script>

<style lang="scss" scoped></style>
